import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ArrowDown from "../../assets/images/arrow-down.svg";
import Report from "../../assets/images/report-block.svg";
import Logout from "../../assets/images/logout.svg";
import { loginService } from "services";
import "./styles.scss";
import { helpLinks } from "shared/app-config";
import InfoCircle from "../../assets/images/info-circle.svg";

const HeaderOptions = ({ user, logout, setShowReport, isAdmin }) => {
  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="info"
        className="rounded-5 me-2 mt-3 option-dropdown-toggle"
      >
        {user} <img src={ArrowDown} alt="down" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="option-select-dropdown rounded-4 shadow-lg border-0">

        {isAdmin && (
          <>
            <Dropdown.Item
              eventKey="2"
              onClick={() => setShowReport(true)}
            >
              <img src={Report} alt="reports"/> Reports
            </Dropdown.Item>
            <Dropdown.Divider />
          </>
        )}
        <Dropdown>
          <Dropdown.Toggle
            variant="info"
            className="rounded-5 me-3 py-1 option-dropdown-toggle d-flex justify-content-between align-items-center px-3 w-100"
          >
            <span className="fw-normal fw-normal d-flex gap-3 help-toggle">
              <img className="me-1" src={InfoCircle} alt="info circle"/>  Help
            </span> <img src={ArrowDown} alt="down" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="help-dropdown">
            <Dropdown.Item className="ps-4 py-2" href={helpLinks.USER_GUIDE} target="_blank">
              Hello User Guide
            </Dropdown.Item>
            <Dropdown.Item className="ps-4 py-2" href={helpLinks.VIDEO_GUIDE} target="_blank">
              Hello Video Guide
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown.Divider />
        <Dropdown.Item eventKey="3" onClick={logout}>
          <img src={Logout} alt="logout"/> Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default HeaderOptions;
